export enum RiskType {
  IDENTITY = 'Identity',
  ACTIVITIES = 'Activities',
  DATA_ACCESS = 'Data Access',
  APPLICATIONS = 'Applications',
  MISCONFIGURATIONS = 'Misconfigurations',
  THIRD_PARTY_APPLICATIONS = '3rd Party Apps',
}
